module.exports = __webpack_public_path__ + "img/avatar_2.dd329f08.svg";